<template>
  <div class="lib__infobox-list">
    <info-box :item="true" :level="isElectricMeter ? 'primary' : 'secondary'">
      <div class="lib__infobox__header__title">
        <h4 v-if="isElectricMeter" class="lib__infobox__megatitle">
          <span v-if="packageKey === '69+'">
            <span class="lib__text-gray-500 lib__text-weight-400 lib__text-no-uppercase">
              {{ $t('meter.electricityPackage.packageLabel') }}
            </span>
            <span>{{ $t('meter.electricityPackage.69+') }}</span>
          </span>
          <span v-else>
            <span v-if="buildingType !== 'building'"
              class="lib__text-gray-500 lib__text-weight-400 lib__text-no-uppercase">
              {{ $t('meter.electricityPackage.packageLabel') }}
            </span>
            <span v-if="buildingType === 'building'"
              class="lib__text-gray-500 lib__text-weight-400 lib__text-no-uppercase">
              {{ $t('meter.electricityPackage.packageLabel') }} {{ $t('new-connection-cmh.address-step.building') }}
            </span>
            <span>{{ packageKey }}</span>
          </span>
        </h4>
        <h4 v-if="isGasMeter" class="lib__infobox__megatitle"><span
            class="lib__text-gray-500 lib__text-weight-400 lib__text-no-uppercase">{{ $t('meter.gasPackage.connection')
            }}</span>
          {{ $t('meter.gasPackage.' + packageKey) }}</h4>
      </div>
      <div class="lib__infobox__header__annexe">
        <h3 v-if="excludingVatPrice > 0 && !isPriceToBeDetermined && buildingType !== 'building'"
          class="lib__text-weight-700">{{ getPrice }}€
        </h3>
        <h4 v-if="buildingType === 'building' || isPriceToBeDetermined && excludingVatPrice <= 0"
          class="lib__text-weight-400 lib__text-no-uppercase">
          {{
            $t('new-connection-cmh.offering-selection-step.priceToBeEstimated') }}</h4>
        <h4 v-if="excludingVatPrice === 0 && !isPriceToBeDetermined" class="lib__text-weight-400 lib__text-no-uppercase">
          {{
            $t('new-connection-cmh.offering-selection-step.free') }}</h4>

      </div>
      <div v-if="excludingVatPrice > 0 && !isPriceToBeDetermined" class="lib__infobox__header__annexe-more">
        <p v-html="$t('meter.uniquePaimentDisclaimer')">
        </p>
      </div>
    </info-box>
    <info-box :item="true" :level="isElectricMeter ? 'primary' : 'secondary'">
      <ul class="lib__infobox__content__data">
        <li v-if="isElectricMeter">
          <div>{{ $t('meter.form.count') }}</div>
          <span class="lib__text-theme lib__text-weight-700">{{ meterCount }} x {{ $tc('meter-box.electricalMeter',
            meterCount) }}</span>
        </li>
        <li v-if="isGasMeter">
          <div>{{ $t('meter.form.count') }}</div>
          <span class="lib__text-theme lib__text-weight-700">{{ meterCount }} x {{ $tc('meter-box.gasMeter',
            meterCount) }}</span>
        </li>
        <li>
          <span v-if="packageKey !== '69+'">{{ $t('meter.maximumPowerGuaranteed') }}</span>
          <span v-if="packageKey === '69+'">{{ $t('meter.maximumPowerWanted') }}</span><br>
          <span v-if="isElectricMeter && packageKey !== '69+'" class="lib__text-theme lib__text-weight-700">{{
            maximumPowerGuaranteed }} {{
    $t('energyProduction.kva') }}</span>
          <span v-if="isElectricMeter && packageKey === '69+'" class="lib__text-theme lib__text-weight-700">{{ wantedPower
          }} {{
  $t('energyProduction.kva') }}</span>
          <span v-if="isGasMeter" class="lib__text-theme lib__text-weight-700">{{ maximumPowerGuaranteed }} {{
            $t('energyProduction.kw')
          }}</span>
          <sup v-if="isElectricMeter" class="lib__tooltips">
            <span class="lib__tooltips__trigger" @click="guaranteedMaximumPowerModalOpen = true">
              <i class="fas fa-info"></i>
            </span>
          </sup>
        </li>
        <li v-if="isElectricMeter && (packageKey === 'Essentiel' || packageKey === 'Confort')">
          {{ $t('meter.form.connectionType') }}<br>
          <span class="lib__text-theme lib__text-weight-700">{{ $t(selectedFunctionality) }}</span>
        </li>
      </ul>
    </info-box>
    <info-box :item="true" :level="isElectricMeter ? 'primary' : 'secondary'">
      <div class="lib__btns-nav-list">
        <button @click="onEdit(identifier)" type="button" class="lib__btn lib__btn--link lib__btn--secondary"><i
            class="fas fa-pencil-alt"></i>
          <span>{{ $t('meter-box.edit') }}</span></button>
        <button v-if="buildingType === 'building' || identifier > 0" @click="onDelete(identifier)"
          type="button" class="lib__btn lib__btn--link lib__btn--danger"><i class="far fa-trash-alt"></i>
          <span>{{ $t('meter-box.delete') }}</span></button>
      </div>
    </info-box>
    <GuaranteedMaximumPowerModal v-model="guaranteedMaximumPowerModalOpen" />
  </div>
</template>
<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import GuaranteedMaximumPowerModal from '@/components/display/CmhNewConnection/GuaranteedMaximumPowerModal.vue'
import { BuildingType } from '@/models/building-type'
import { pricingService } from '@/services/pricing-service'

@Component({
  name: 'package-editable-box',
  components: {
    GuaranteedMaximumPowerModal
  }
})
export default class PackageEditableBox extends Vue {
  @Prop({ type: Boolean, required: true }) public isElectricMeter!: boolean
  @Prop({ type: Boolean, required: true }) public isGasMeter!: boolean
  @Prop({ type: String, required: true }) public packageKey!: string
  @Prop({ type: Number, required: true }) public meterCount!: number
  @Prop({ type: Number, required: true }) public maximumPowerGuaranteed!: number
  @Prop({ type: String, required: false }) public selectedFunctionality!: string
  @Prop({ type: Number, required: true }) public identifier!: number
  @Prop({ type: Number, required: false, default: 0 }) public excludingVatPrice!: number
  @Prop({ type: Boolean, required: true }) public isPriceToBeDetermined!: boolean
  @Prop({ type: Boolean, required: false, default: false }) isCustomPower!: boolean
  @Prop({ type: Number, required: false }) wantedPower!: number
  @Prop({ type: String, required: false }) buildingType!: BuildingType

  @Prop({ type: Function, required: true }) public onEdit!: (identifier: number) => void
  @Prop({ type: Function, required: true }) public onDelete!: (identifier: number) => void

  public guaranteedMaximumPowerModalOpen: boolean = false

  //#region [Computed]
  public get getPrice(): string {
    return pricingService.formatNumberToLocaleStringFormat(this.excludingVatPrice)
  }
  //#endregion
}
</script>